// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hbV4q","largestCol":"styles_largestCol__3HQmw","smallestCol":"styles_smallestCol__1sSal"};